import { render, staticRenderFns } from "./CampaignShow.vue?vue&type=template&id=47b7ae60&"
import script from "./CampaignShow.vue?vue&type=script&lang=js&"
export * from "./CampaignShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports